export default "__VITE_ASSET__DBpghgMd__"